import React from 'react';

import { ia } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import ReceiptTransactionsTableMobile from './ReceiptTransactionsTableMobile';
import TransactionsTable from './TransactionsTable';

const ReceiptTransactions = ({ transactions, timezone }) => {
  if (!ia(transactions)) return null;

  return (
    <div className="flex flex-col gap-3 px-2 md:px-6">
      <Typography variant="p" size="small" weight="medium" color="neutral-500">
        Payment History
      </Typography>
      <TransactionsTable transactions={transactions} timezone={timezone} />
      <ReceiptTransactionsTableMobile transactions={transactions} timezone={timezone} />
    </div>
  );
};

export default ReceiptTransactions;
